export function universalBlogEditorPath(contentId: string): string {
  return `/editor/blog/${encodeURIComponent(contentId)}`;
}
